module.exports = __webpack_public_path__ + "img/1009.544f70a9.jpg";